import React, { useState } from "react";
import axios from "axios";
import {
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
  Stack,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { getAuthHeaders } from "../context/AuthContext";
// import { REACT_APP_API_BASE_URL } from "../config";
import { SKUPrefixes } from "../enums/skuPrefixes";
import { getApiUrl } from "../utils/apiHelper";
import { useAuth } from "../context/AuthContext";

import SearchResults from "./search_results";
import ImageUploader from "./image_uploader";

function Search() {
  const { loginType } = useAuth();
  const [file, setFile] = useState(null);
  const [method] = useState("vertex_gemini_chroma");
  const [catalogCategory, setCatalogCategory] = useState(null);
  const [client, setClient] = useState("giva");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [results, setResults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filters, setFilters] = useState({ status: ["active"] });
  const [imageKey, setImageKey] = useState(null);
  const [hasSearched, setHasSearched] = useState(false);
  const [reported, setReported] = useState(false);
  const [removeBackground, setRemoveBackground] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const handleSearch = async () => {
    const headers = await getAuthHeaders();
    if (!file) {
      alert("Please select an image to search");
      return;
    }

    setLoading(true);
    try {
      const presignRes = await axios.get(
        getApiUrl(loginType, "/get-upload-url/"),
        { headers }
      );
      const { upload_url, image_key } = presignRes.data;
      setImageKey(image_key);

      await axios.put(upload_url, file, {
        headers: {
          "Content-Type": "image/jpeg",
        },
      });

      const cleanedFilters = Object.fromEntries(
        Object.entries(filters).filter(([_, value]) => {
          if (Array.isArray(value)) {
            return value.length > 0;
          }
          return value !== null && value !== undefined && value !== "";
        })
      );

      if (catalogCategory === "gold" && !cleanedFilters.sku_pref) {
        cleanedFilters.sku_pref = SKUPrefixes.GOLD;
      } else if (catalogCategory === "silver" && !cleanedFilters.sku_pref) {
        cleanedFilters.sku_pref = SKUPrefixes.SILVER;
      } else if (catalogCategory === "onnme" && !cleanedFilters.sku_pref) {
        cleanedFilters.sku_pref = SKUPrefixes.ONNME;
      }

      const searchRes = await axios.post(
        getApiUrl(loginType, "/search/"),
        {
          query_gcs_key: image_key,
          method: method,
          params: {
            top_k: 25,
            filters: cleanedFilters,
            client: client,
            remove_background: removeBackground,
          },
        },
        { headers }
      );

      setResults(searchRes.data.results);
      setReported(false);
      setHasSearched(true);
    } catch (error) {
      console.error("Search error:", error);
      alert("Search failed. See console for details.");
      setHasSearched(true);
    }
    setLoading(false);
  };

  return (
    <Container maxWidth="lg" sx={{ mt: isMobile ? 2 : 4, px: isMobile ? 2 : 0 }}>
      <Typography variant="h4" align="center" gutterBottom fontWeight={600}>
        Image Search
      </Typography>
      <Typography variant="body2" align="center" color="text.secondary" mb={3}>
        Upload an image to search with your selected method.
      </Typography>

      <Stack
        direction="column"
        spacing={2}
        mb={3}
        alignItems="center"
        width="100%"
      >
        <Box flex={1} width="100%">
          <ImageUploader
            file={file}
            setFile={setFile}
            previewUrl={previewUrl}
            setPreviewUrl={setPreviewUrl}
            catalogCategory={catalogCategory}
            setCatalogCategory={setCatalogCategory}
            client={client}
            setClient={setClient}
            filters={filters}
            setFilters={setFilters}
            hasSearched={hasSearched}
            setHasSearched={setHasSearched}
            removeBackground={removeBackground}
            setRemoveBackground={setRemoveBackground}
          />
        </Box>
        <Button
          variant="contained"
          onClick={handleSearch}
          disabled={loading || !file}
          fullWidth={isMobile}
          sx={{
            minWidth: isMobile ? "100%" : 160,
            mt: 1,
            alignSelf: isMobile ? "stretch" : "center",
          }}
        >
          {loading ? <CircularProgress size={24} color="inherit" /> : "Search"}
        </Button>
      </Stack>

      <SearchResults
        results={results}
        method={method}
        image_key={imageKey}
        file={file}
        hasSearched={hasSearched}
        reported={reported}
        setReported={setReported}
        client={client} // <-- pass client here
      />
    </Container>
  );
}

export default Search;
